import { render, staticRenderFns } from "./ResourcesSettingInfo.vue?vue&type=template&id=1b44cf08&"
import script from "./ResourcesSettingInfo.vue?vue&type=script&lang=js&"
export * from "./ResourcesSettingInfo.vue?vue&type=script&lang=js&"
import style0 from "./ResourcesSettingInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports